import qs from "qs";

interface ParamsSerializerOptions {
  allowEmptyArrays?: boolean;
  skipNulls?: boolean;
  arrayFormat?: "brackets" | "comma";
}

export const paramsSerializer = (
  params: Record<string, unknown>,
  options: ParamsSerializerOptions = {},
): string =>
  qs.stringify(params, {
    arrayFormat: options.arrayFormat ?? "brackets",
    allowEmptyArrays: options.allowEmptyArrays,
    skipNulls: options.skipNulls,
  });
